import { feeds } from "../../apis/services";
import {
  FETCH_CONSTRUCTOR_STATISTICS,
  FETCH_DRIVER_STATISTICS,
  FETCH_RAW_STATISTICS,
  FETCH_STATISTICS,
  FETCH_COMMON_STATISTICS,
} from "../../constants/statistics";

export const getStatistics = (playerId, livePointsBuster = false) => ({
  type: FETCH_STATISTICS,
  payload: feeds.getPlayerStatistics(playerId, livePointsBuster),
});

export const getRawStatistics = (playerId) => ({
  type: FETCH_RAW_STATISTICS,
  payload: feeds.getPlayerStatistics(playerId),
});

export const getDriverStatistics = ({ list: drivers, url, tourId }) => ({
  type: FETCH_DRIVER_STATISTICS,
  payload: async () => {
    const data = await feeds.getDriverStatistics({ url, tourId });
    return { ...data, drivers };
  },
});

export const getConstructorStatistics = ({
  list: constructors,
  url,
  tourId,
}) => ({
  type: FETCH_CONSTRUCTOR_STATISTICS,
  payload: async () => {
    const data = await feeds.getConstructorStatistics({ url, tourId });
    return { ...data, constructors };
  },
});

export const getCommonStatistics = ({ list, url, tourId }) => ({
  type: FETCH_COMMON_STATISTICS,
  payload: async () => {
    const data = await feeds.getCommonStatisticsV2({ url, tourId });
    return { ...data, list };
  },
});
